import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, ArrowRight, Package, DollarSign, Users, Wrench } from 'lucide-react';
import { servicesData } from '../mockData';

export const SalesPage = () => {
  const { sales } = servicesData;

  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 via-white to-cyan-50 py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-6">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900">
              {sales.title}
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {sales.description}
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-12 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Por Que Escolher a Visiomed?
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {sales.benefits.map((benefit, index) => (
              <Card key={index} className="hover:shadow-lg transition-shadow duration-300">
                <CardContent className="p-6 flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <CheckCircle className="text-green-600" size={24} />
                  </div>
                  <p className="text-gray-700 font-medium">{benefit}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 bg-gray-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-12 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Nosso Processo de Vendas
            </h2>
            <p className="text-xl text-gray-600">
              Simples, transparente e focado no cliente
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center space-y-4">
              <div className="mx-auto h-16 w-16 bg-blue-100 rounded-full flex items-center justify-center">
                <Users className="text-blue-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900">1. Consulta</h3>
              <p className="text-gray-600">
                Entendemos suas necessidades e recomendamos as melhores soluções
              </p>
            </div>
            <div className="text-center space-y-4">
              <div className="mx-auto h-16 w-16 bg-blue-100 rounded-full flex items-center justify-center">
                <DollarSign className="text-blue-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900">2. Orçamento</h3>
              <p className="text-gray-600">
                Preços competitivos e condições comerciais adequadas
              </p>
            </div>
            <div className="text-center space-y-4">
              <div className="mx-auto h-16 w-16 bg-blue-100 rounded-full flex items-center justify-center">
                <Package className="text-blue-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900">3. Entrega</h3>
              <p className="text-gray-600">
                Instalação profissional e configuração em sua instalação
              </p>
            </div>
            <div className="text-center space-y-4">
              <div className="mx-auto h-16 w-16 bg-blue-100 rounded-full flex items-center justify-center">
                <Wrench className="text-blue-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900">4. Suporte</h3>
              <p className="text-gray-600">
                Treinamento contínuo e suporte técnico
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-16 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-12 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Equipamentos Disponíveis
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {[
              { name: 'Ressonância Magnética', href: '/ressonancia' },
              { name: 'Tomógrafo', href: '/tomografia' },
              { name: 'Ultrassom', href: '/ultrassom' },
              { name: 'Densitometria Óssea', href: '/densitometria' },
              { name: 'Mamógrafo', href: '/mamografia' },
              { name: 'Raio-X', href: '/raio-x' },
              { name: 'CR', href: '/cr' },
              { name: 'DR', href: '/dr' },
              { name: 'Workstation', href: '/workstation' },
              { name: 'PACS', href: '/pacs' }
            ].map((item, index) => (
              <Link key={index} to={item.href}>
                <Card className="hover:border-blue-600 hover:shadow-lg transition-all duration-300 h-full cursor-pointer">
                  <CardContent className="p-6 text-center space-y-2">
                    <div className="mx-auto h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center">
                      <CheckCircle className="text-blue-600" size={24} />
                    </div>
                    <p className="font-semibold text-gray-900 text-sm">{item.name}</p>
                    <p className="text-xs text-blue-600">Ver detalhes →</p>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
          <div className="mt-8 text-center">
            <Link to="/equipment">
              <Button className="bg-blue-600 hover:bg-blue-700 text-white">
                Ver Todos os Equipamentos
                <ArrowRight className="ml-2" size={18} />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <div className="space-y-6">
            <h2 className="text-3xl sm:text-4xl font-bold text-white">
              Pronto para Comprar?
            </h2>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto">
              Entre em contato para um orçamento personalizado e consulta
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-6 text-lg">
                Solicitar Informações
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};